<div class="home-container">
  <!-- Valentine's promo banner -->
  @if (showValentinesBanner) {
    <div class="valentines-banner-wrapper">
      <div class="valentines-banner">
        <p class="valentines-banner-title">{{ 'HOME.VALENTINES_BANNER.TITLE' | translate }}</p>
        <!-- <p class="valentines-banner-title">{{ 'HOME.VALENTINES_BANNER.CTA' | translate }}</p> -->
        <div class="d-flex align-items-center justify-content-center" style="gap: 0.5rem;">
          <p class="valentines-banner-title">{{ 'HOME.VALENTINES_BANNER.CTA' | translate }}</p>
          <!-- <span class="valentines-banner-cta">{{ 'HOME.VALENTINES_BANNER.CTA' | translate }}</span> -->
          @if (isUploadMode && designQueue.length === 0) {
            <button
              class="valentines-banner-button"
              (click)="scrollToUploadSection()">
              {{ 'HOME.VALENTINES_BANNER.BUTTON' | translate }}
            </button>
          }
        </div>
      </div>
    </div>
  }
  <div class="container" [ngClass]="{
      'editor-container': isEditMode,
      'content-below-valentines-banner': showValentinesBanner
    }">
    <!-- Upload Mode -->
    @if (isUploadMode) {
      <div>
        <header class="header">
          <img loading="lazy" width="74" height="48" src="../../assets/images/gulli-logo.svg" alt="Gulli Logo">
          <p class="subtitle">
            {{ 'HOME.SUBTITLE' | translate }}
            <span>{{ 'HOME.SUBTITLESPAN' | translate }}</span>
          </p>
        </header>
        <div class="preview mt-3 mb-3" [ngStyle]="{'margin': hideHeroVideo ? '0' : '2rem 0'}">
          <!-- <div class="preview-header">
          <h2>{{ 'HOME.PREVIEW' | translate }}</h2>
          <div *ngIf="editorState.isFinishedEditing && designQueue.length === 0" class="preview-header-buttons">
            <button (click)="returnToEditMode()"><img loading="lazy" width="36" height="36" loading="lazy"
            src="../../assets/images/edit.svg" alt=""></button>
            <button (click)="switchToUploadMode()"><img loading="lazy" width="36" height="36"
            src="../../assets/images/delete.svg" alt=""></button>
          </div>
        </div> -->
        @if (!editorState.isImageSelected && designQueue.length === 0) {
          <div>
            <!-- Loader while GIF is loading -->
            @if (!isGifLoaded) {
              <div class="gif-loader-container">
                <span class="gif-loader"></span>
              </div>
            }
            <!-- GIF and content - shown after loading -->
            <div class="hero-content">
              <!-- <video
              #heroVideo
              autoplay
              loop
              muted
              playsinline
              width="100%"
              height="360"
              style="object-fit: cover; pointer-events: none; border-radius: 16px;">
              <source src="../../assets/video/gif1.mp4" type="video/mp4">
              Your browser does not support the video tag.
            </video> -->
            <h2 >{{ 'HOME.HERO.TITLE' | translate }}</h2>
            <p>{{ 'HOME.HERO.DESCRIPTION' | translate }}</p>
          </div>
        </div>
      }
    </div>
    <!-- Gulli Sticker Section (Main Store Only) -->
    @if (isMainStore && !editorState.isImageSelected && designQueue.length === 0) {
      <app-gulli-sticker></app-gulli-sticker>
    }
    <!-- Divider between Sticker and Make Your Own -->
    @if (isMainStore && !editorState.isImageSelected && designQueue.length === 0) {
      <div class="section-divider">
        <span class="divider-line"></span>
        <span class="divider-text">{{ 'HOME.OR' | translate }}</span>
        <span class="divider-line"></span>
      </div>
    }
    <div #uploadSection class="upload-container" [style.display]="designQueue.length > 0 ? 'none' : 'block'" [ngStyle]="{'margin-top': hideHeroVideo ? '0' : '2rem'}">
      <div class="upload-card">
        <div class="upload-header">
          <div class="upload-icon">
            <img loading="lazy" width="36" height="36" src="../../assets/images/upload.svg" alt="Upload Photo">
          </div>
          <h2>{{ 'HOME.MAKE_YOUR_OWN.TITLE' | translate }}</h2>
          <p class="upload-subtitle">{{ 'HOME.MAKE_YOUR_OWN.SUBTITLE' | translate }}</p>
        </div>
        <!-- Hidden file input -->
        <input #fileInput type="file" accept="image/jpeg,image/png" style="display: none;"
          (change)="onFileSelected($event)">
        <!-- Upload area -->
        <div class="upload-area" (click)="triggerFileInput()">
          <div class="upload-content">
            <div class="upload-plus">+</div>
            <span class="upload-text">{{ 'HOME.CLICK_TO_UPLOAD' | translate }}</span>
          </div>
        </div>
        <div class="upload-info">
          <div class="info-item">
            <span class="info-icon">📷</span>
            <span>{{ 'HOME.ACCEPTED_FORMATS' | translate }}</span>
          </div>
          <div class="info-item">
            <span class="info-icon">✨</span>
            <span>{{ 'HOME.BEST_RESULTS' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Shopify Products Section (Main Store Only) -->
    @if (isMainStore && !editorState.isImageSelected && designQueue.length === 0) {
      <app-shopify-products></app-shopify-products>
    }
    <!-- Floating Cart Button (only in homepage/upload state – hidden when purchase-controls bar is visible) -->
    @if (isMainStore && !editorState.isImageSelected && totalCartItems > 0 && designQueue.length === 0) {
      <button
        class="floating-cart-btn"
        (click)="openCartModal()">
        <img loading="lazy" src="../../assets/images/cart.svg" alt="Cart" class="cart-icon">
        <span class="cart-count">{{ totalCartItems }}</span>
      </button>
    }
    @if (designQueue.length > 0) {
      <div class="flip-box"
        [ngStyle]="{'transform': getLastDesign()?.isPortrait ? 'rotate(270deg)' : '', 'margin': getLastDesign()?.isPortrait ? '84px 0px' : '8% 0%'}"
        appCardRotation>
        <div class="flip-box-inner"
          [ngStyle]="{animation: getLastDesign()?.isPortrait ? 'spinX 3s ease-in-out' : 'spinY 3s ease-in-out'}">
          <div class="flip-box-front">
            <img [src]="getLastDesign()?.base64Image" alt="" />
          </div>
          <div class="flip-box-back">
            <img src="../../assets/images/text.svg" alt="" />
          </div>
        </div>
      </div>
    }
    @if (!editorState.isImageSelected && designQueue.length === 0) {
      <div class="clients-info">
        @if (!hideHeroVideo) {
          <div>        <app-clients-creations></app-clients-creations></div>
        }
        <app-reviews></app-reviews>
      </div>
    }
    <!-- Q&A Section -->
    @if (!editorState.isImageSelected && designQueue.length === 0) {
      <app-qa></app-qa>
    }
    @if (designQueue.length > 0) {
      <div #locationSection class="location">
        <div class="location-top-wrapper">
          <h2 [innerHTML]="'HOME.LOCATION.TITLE' | translate"></h2>
          <button (click)="openLocationInfoModal()" type="button" aria-label="Why is location required?"><img loading="lazy" src="../../assets/images/Info.svg"
          alt=""></button>
        </div>
        <ng-template #mapHost></ng-template>
        <small>{{ 'HOME.LOCATION.HELP' | translate }}</small>
      </div>
    }
    @if (designQueue.length > 0) {
      <app-purchase-controls
        [quantity]="getTotalQuantity()"
        [isFinishedEditing]="true"
        [isProcessingOrder]="editorState.isProcessingOrder"
        [price]="price"
        [valentinesBundle]="valentinesBundleConfig"
        [hideQuantityControls]="true"
        [designs]="designQueue"
        [allDesignsHaveLocation]="allDesignsHaveLocation()"
        (buyNow)="buyNow()"
        (quantityChange)="onQuantityChange($event)"
        (updateDesignQuantity)="onUpdateDesignQuantity($event)"
        (removeDesign)="removeDesign($event)"
        (editDesign)="editDesign($event)"
        (addAnotherDesign)="addAnotherDesign()"
        (openAllMagnets)="goToAllMagnetsFromFinish()">
      </app-purchase-controls>
    }
  </div>
}

<!-- Edit Mode -->
@if (isEditMode) {
  <div class="editor-mode">
    <!-- Tutorial overlay -->
    <header class="editor-header">
      <!-- <h1>Edit photo</h1> -->
      @if (textOverlay.isTyping) {
        <button class="text-done-btn" (click)="onDoneClick()">
          {{ 'HOME.DONE' | translate }}
        </button>
      }
    </header>
    <div #imageEditor class="image-editor">
      <div class="image-container">
        <!-- Semi-transparent background image -->
        <div class="outer-image-container">
          <img loading="lazy" [src]="editorState.selectedImage" [ngStyle]="imageTransformStyle" alt="Background Image">
        </div>
        <!-- Fixed frame with exact dimensions -->
        <div #magnetFrame class="magnet-frame" [ngClass]="{'portrait': editorState.isPortraitImage}" [ngStyle]="frameStyle">
          <span></span>
          <div class="image-frame" [class.typing-mode]="textOverlay.isTyping">
            <img loading="lazy" #editableImage [src]="editorState.selectedImage" [ngStyle]="imageTransformStyle"
              alt="Editable Image">
          </div>
          <!-- Text overlay if added -->
          @if (textOverlay.overlayText && !textOverlay.isTyping) {
            <div class="text-overlay" [style.left.%]="textOverlay.textPositionX"
              [style.top.%]="textOverlay.textPositionY" [ngStyle]="getTextStyle()" (mousedown)="startTextDrag($event)"
              (mouseup)="stopTextDrag($event)" (mouseleave)="stopTextDrag($event)" (touchstart)="startTextDrag($event)"
            (touchmove)="moveText($event)" (touchend)="stopTextDrag($event)" (touchcancel)="stopTextDrag($event)">{{textOverlay.overlayText}}</div>
          }
          <!-- Live text preview while typing -->
          <div>
            <div [hidden]="!textOverlay.isTyping" class="text-overlay typing-mode" [style.left.%]="textOverlay.textPositionX" [style.top.px]="120"
              [ngStyle]="getTextStyle()" contenteditable="true" (input)="onContentEditableInput($event)"
            (blur)="onBlur()" (keydown)="handleKeyboardInput($event)" #contentEditableDiv></div>
          </div>
          @if (uiState.showTutorial) {
            <div class="tutorial-overlay">
              <div class="tutorial-content">
                <!-- <app-lottie></app-lottie> -->
                <ng-template #lottieHost></ng-template>
                <p class="tutorial-text">{{ 'HOME.PINCH_DRAG' | translate }}</p>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <!-- Text styling options when in typing mode -->
    @if (textOverlay.isTyping) {
      <div class="text-styling-options">
        <!-- Color selection -->
        <div class="styling-section">
          <div class="color-options">
            @for (color of textOverlay.availableColors; track color; let i = $index) {
              <div class="color-option"
                [style.background-color]="color" [class.selected]="i === textOverlay.selectedColorIndex" (click)="selectColor(i)">
                @if (i === textOverlay.selectedColorIndex) {
                  <div class="color-selected-indicator"></div>
                }
              </div>
            }
          </div>
        </div>
        <!-- Font selection -->
        <div class="styling-section">
          <div class="font-options">
            @for (font of textOverlay.availableFonts; track font; let i = $index) {
              <div class="font-option" [style.font-family]="font"
                [class.selected]="i === textOverlay.selectedFontIndex" (click)="selectFont(i)">
                Aa
              </div>
            }
          </div>
        </div>
      </div>
    }
  <!-- </div> -->
  <!-- Editor footer with controls -->
  <div class="editor-footer" [class.hidden]="textOverlay.isTyping">
    <button class="btn-icon" (click)="switchToUploadMode()">
      <img loading="lazy" width="38" height="38" src="../../assets/images/XCircle.svg"
        alt="{{ 'HOME.BACK' | translate }}">
    </button>
    <button class="btn-icon" (click)="rotateLeft()">
      <img loading="lazy" width="38" height="38" src="../../assets/images/rotateleft.svg"
        alt="{{ 'HOME.ROTATE_LEFT' | translate }}">
    </button>
    <button class="btn-icon" (click)="rotateRight()">
      <img loading="lazy" width="38" height="38" src="../../assets/images/Rotateright.svg"
        alt="{{ 'HOME.ROTATE_RIGHT' | translate }}">
    </button>
    <!-- <button class="btn-icon" (click)="toggleDisplayMode()" [class.active]="displayMode === 'fit'">
    <span class="icon-text">{{ displayMode === 'fill' ? 'Fill' : 'Fit' }}</span>
  </button> -->
  <button class="btn-icon" [class.active]="textOverlay.isTyping" (click)="toggleTextInput()">
    <span class="icon-text">Aa</span>
  </button>
  <button class="btn-icon" (click)="finishEditing()">
    <img loading="lazy" width="38" height="38" src="../../assets/images/CheckCircle.svg" alt="Done">
  </button>
</div>
</div>
}

<div class="loading-overlay" [class.show]="editorState.isProcessingEdit || editorState.isLoadingImage">
  <span class="loader"></span>
</div>
</div>
</div>

<!-- Pan indicators - will show when image extends beyond frame bounds -->
<!-- <div *ngIf="isEditMode" class="pan-indicators">
<div class="pan-indicator horizontal"
  *ngIf="(imageTransform.maxWidth * (imageTransform.rotation % 180 === 0 ? 1 : imageTransform.maxHeight/imageTransform.maxWidth)) > frameBounds.width">
  <div class="pan-arrow left"></div>
  <div class="pan-arrow right"></div>
</div>
<div class="pan-indicator vertical"
  *ngIf="(imageTransform.maxHeight * (imageTransform.rotation % 180 === 0 ? 1 : imageTransform.maxWidth/imageTransform.maxHeight)) > frameBounds.height">
  <div class="pan-arrow up"></div>
  <div class="pan-arrow down"></div>
</div>
</div> -->

<!-- <div class="styling-container" [class.keyboard-visible]="isKeyboardVisible">
</div> -->


<!-- Add this near the end of your template -->
@if (uiState.showDiscardModal) {
  <div class="discard-modal" [class.show]="uiState.isModalOpen">
    <div class="modal-content">
      <p>{{ 'HOME.DISCARD_CHANGES' | translate }}</p>
      <div class="modal-actions">
        <button class="btn-secondary" (click)="cancelDiscard()">{{ 'HOME.CANCEL' | translate }}</button>
        <button class="btn-primary" (click)="confirmDiscard()">{{ 'HOME.CONFIRM' | translate }}</button>
      </div>
    </div>
  </div>
}


@if (uiState.showLocationInfo) {
  <div class="location-modal" [class.show]="uiState.showLocationInfo">
    <div class="modal-content">
      <h4 [innerHTML]="'HOME.LOCATION_MODAL.TITLE' | translate"></h4>
      <div class="modal-actions">
        <button class="btn-primary" (click)="closeLocationModalAndFocusMap()">{{ 'HOME.LOCATION_MODAL.ADD_LOCATION' | translate }}</button>
        <button class="btn-secondary" (click)="uiState.showLocationInfo = false">{{ 'HOME.LOCATION_MODAL.UNDERSTAND' | translate }}</button>
      </div>
    </div>
  </div>
}

<!-- Cart Modal -->
@if (showCartModal) {
  <div class="cart-modal-backdrop" (click)="closeCartModal()"></div>
}
<div class="cart-modal" [class.cart-modal--open]="showCartModal" role="dialog" aria-modal="true">
  <div class="cart-modal-header">
    <h3 class="cart-modal-title">{{ 'HOME.YOUR_CART' | translate }}</h3>
    <button class="cart-modal-close" (click)="closeCartModal()" aria-label="Close">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <div class="cart-modal-body">
    <!-- Empty cart state -->
    @if (totalCartItems === 0) {
      <div class="cart-modal-empty">
        <img loading="lazy" src="../../assets/images/cart.svg" alt="Cart" class="cart-modal-empty-icon">
        <p>{{ 'HOME.CART_EMPTY' | translate }}</p>
      </div>
    }

    <!-- Custom Designs Section -->
    @if (designQueue.length > 0) {
      <div class="cart-modal-section">
        <h4 class="cart-modal-section-title">{{ 'HOME.CUSTOM_MAGNETS' | translate }}</h4>
        @for (design of designQueue; track design; let i = $index) {
          <div class="cart-modal-item">
            <div class="cart-modal-item-thumb">
              <img [src]="design.thumbnailUrl" alt="Design {{i + 1}}">
            </div>
            <div class="cart-modal-item-info">
              <span class="cart-modal-item-name">{{ 'HOME.DESIGN' | translate }} #{{i + 1}}</span>
              <span class="cart-modal-item-price">{{ formatCartPrice(design.quantity * (price?.price?.amount ? +price.price.amount : 0)) }}</span>
            </div>
            <div class="cart-modal-item-qty">
              <button (click)="onUpdateDesignQuantity({id: design.id, quantity: design.quantity - 1})" [disabled]="design.quantity <= 1">
                <img loading="lazy" width="16" height="16" src="../../assets/images/Minus.svg" alt="-">
              </button>
              <span>{{design.quantity}}</span>
              <button (click)="onUpdateDesignQuantity({id: design.id, quantity: design.quantity + 1})">
                <img loading="lazy" width="16" height="16" src="../../assets/images/Plus.svg" alt="+">
              </button>
            </div>
          </div>
        }
      </div>
    }

    <!-- Shopify Products Section -->
    @if (cartShopifyProducts.length > 0) {
      <div class="cart-modal-section">
        <h4 class="cart-modal-section-title">{{ 'HOME.SHOPIFY_PRODUCTS_CART' | translate }}</h4>
        @for (item of cartShopifyProducts; track item) {
          <div class="cart-modal-item">
            <div class="cart-modal-item-thumb">
              <img [src]="item.product.imageUrl" [alt]="item.product.title">
            </div>
            <div class="cart-modal-item-info">
              <span class="cart-modal-item-name">{{item.product.title}}</span>
              <span class="cart-modal-item-price">{{ formatCartPrice(+item.product.price.amount * item.quantity) }}</span>
            </div>
            <div class="cart-modal-item-qty">
              <button (click)="updateCartShopifyQuantity(item.product.id, item.quantity - 1)" [disabled]="item.quantity <= 1">
                <img loading="lazy" width="16" height="16" src="../../assets/images/Minus.svg" alt="-">
              </button>
              <span>{{item.quantity}}</span>
              <button (click)="updateCartShopifyQuantity(item.product.id, item.quantity + 1)">
                <img loading="lazy" width="16" height="16" src="../../assets/images/Plus.svg" alt="+">
              </button>
            </div>
            <button class="cart-modal-item-remove" (click)="removeCartShopifyProduct(item.product.id)" aria-label="Remove">
              <img loading="lazy" width="24" height="24" src="../../assets/images/delete.svg" alt="Remove">
            </button>
          </div>
        }
      </div>
    }
  </div>

  @if (totalCartItems > 0) {
    <div class="cart-modal-footer">
      <div class="cart-modal-total">
        <span class="cart-modal-total-label">{{ 'HOME.TOTAL' | translate }}</span>
        <span class="cart-modal-total-amount">{{ formatCartPrice(cartModalTotal) }}</span>
      </div>
      <button class="cart-modal-checkout-btn"
        (click)="checkoutFromModal()"
        [disabled]="editorState.isProcessingOrder">
        @if (!editorState.isProcessingOrder) {
          <span>{{ 'HOME.BUY_NOW' | translate }}</span>
        }
        @if (editorState.isProcessingOrder) {
          <span>...</span>
        }
      </button>
      <button class="cart-modal-continue-btn" (click)="closeCartModal()">
        {{ 'HOME.CONTINUE_SHOPPING' | translate }}
      </button>
    </div>
  }
</div>

<app-footer [isFinishedEditing]="editorState.isFinishedEditing"></app-footer>